import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Badge, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../css/global.css';

import NewsIcon from '../assets/icon/news.svg';

const MenuItem = (props: any): any => {
  const { id, name, subMenus, Icon, onClick, to, amountNotification } = props;
  const [expand, setExpand] = useState(false);

  // Renomeado o parâmetro para tooltipProps para evitar conflito
  const renderTooltip = (tooltipProps: any): JSX.Element => (
    <Tooltip id={`tooltip-${id}`} {...tooltipProps} className="custom-tooltip">
      {name}
    </Tooltip>
  );

  return (
    <li className={`${id === 7 ? 'side-menu-footer mb-5 pb-5 ps-3 pe-3' : ''}`}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 200 }}
        overlay={renderTooltip}
      >
        <button
          type="button"
          onClick={onClick}
          className="w-100 border-0 bg-transparent"
        >
          {amountNotification > 0 && (
            <Image
              src={NewsIcon}
              style={{
                maxHeight: '1.25rem',
                maxWidth: '2rem',
              }}
              alt="Notificação"
              className="position-fixed ms-1 mt-2"
            />
          )}

          <NavLink
            to={to}
            onClick={() => setExpand(!expand)}
            className="menu-item mb-2"
          >
            <div className="menu-icon">
              {/* <Icon /> */}
              <Image
                src={Icon}
                alt={name}
                // style={{ width: '60%', height: '60%' }}
                style={{ maxHeight: '2.4rem' }}
              />
            </div>
            <span>{name}</span>
          </NavLink>
          {subMenus && subMenus.length > 0 ? (
            <ul className={`sub-menu ${expand ? 'active' : ''}`}>
              {subMenus.map((menu: any) => (
                <li key={menu.id}>
                  <NavLink to={menu.to}>{menu.name}</NavLink>
                </li>
              ))}
            </ul>
          ) : null}
        </button>
      </OverlayTrigger>
    </li>
  );
};

export default MenuItem;
